module.exports = __webpack_public_path__ + "img/scene.46261bb9.png";